//Data that contains year information that is used to render graphs for each year listed

export const years = [
    {
        year: 2020,
        start: "2020-01-01",
        end: "2020-12-31"
    },
    {
        year: 2021,
        start: "2021-01-01",
        end: "2021-12-31"
    },
    {
        year: 2022,
        start: "2022-01-01",
        end: "2022-12-31"
    },
    {
        year: 2023,
        start: "2023-01-01",
        end: "2023-12-31"
    },
]